import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg2",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs2" }), /* @__PURE__ */ _jsx("path", {
		id: "path3",
		d: "m 15.462891,8.9414063 c -0.191925,0 -0.384801,0.0723 -0.53125,0.21875 L 10.845703,13.248047 9.0644531,11.470703 c -0.2929597,-0.2928 -0.7677271,-0.293 -1.0605468,0 -0.2928298,0.2929 -0.2910066,0.767747 0.00195,1.060547 l 2.3085937,2.308594 c 0.2929,0.292799 0.767747,0.292899 1.060547,0 l 4.617188,-4.617188 c 0.292899,-0.2928595 0.292899,-0.76961 0,-1.0624997 -0.14645,-0.1464499 -0.337373,-0.21875 -0.529297,-0.21875 z M 12,2.25 c -5.3851192,0 -9.75,4.3648808 -9.75,9.75 0,5.384089 4.3648208,9.75 9.75,9.75 5.385189,0 9.75,-4.365911 9.75,-9.75 0,-5.3851192 -4.364911,-9.75 -9.75,-9.75 z m 0,1.5 c 4.556691,0 8.25,3.6932991 8.25,8.25 0,4.555691 -3.693409,8.25 -8.25,8.25 C 7.4433591,20.25 3.75,16.555691 3.75,12 3.75,7.4432991 7.4432991,3.75 12,3.75 Z"
	})]
});
export default SvgCheckCircleLine;
